import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SuivieRecommandation } from 'src/app/shared/models/remmandation';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-traitement-recommendation',
  standalone: false,
  templateUrl: './traitement-recommendation.component.html',
  styleUrl: './traitement-recommendation.component.scss'
})

export class TraitementRecommendationComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;
  filteredData: any[] = []; // Données filtrées
  searchTerm: string = ''; // Terme de recherche
  recommadationItems: any = [];
  modalRef: NgbModalRef | null = null;
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  item: SuivieRecommandation = new SuivieRecommandation()
  itemToDelete!: any;
  @ViewChild('recoommandationModal') modalContent: TemplateRef<any>;
  missionItems: any[] = [];
  typemissionItems: any[] = [];
  serviceItems: any[] = [];



  paginatedItems1: any[] = [];
  first1: number = 0;
  rows1: number = 10;
  totalRecords1: number = 0;
  traitemeentItems: any = [];

  id: any;
  constructor(
    private modalService: NgbModal,

    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private route: ActivatedRoute,
  ) {

    // this.projetService.projetCreated$.subscribe(() => {
    //   this.fetchDataAction();
    // });
  }

  ngOnInit(): void {
    //   //console.log(" this.localstorage.getUsers().data.reference", this.localstorage.getInfoUserToService());

    this.item.user_reference = this.localstorage.getInfoUserToService()?.data?.reference
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      //console.log("ID récupéré :", this.id); // Doit afficher quelque chose comme "9f0ae00b-..."
    });
    this.getRecommandation(this.id);

  }

  getRecommandation(item: any) {
    this.isLoading = true;

    this.paramservice.getsuiviRecommadationByRecommdation(item).subscribe(
      (response: any) => {
        this.traitemeentItems = response.data;
        this.totalRecords = this.traitemeentItems.length
        this.updatePagination();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }


  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagination();
  }


  updatePagination() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.traitemeentItems.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }
  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.recommadationItems.filter(item =>
        item.libelle.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.recommadationItems];
    }

    this.totalRecords = this.filteredData.length;
    this.first = 0; // Revenir à la première page après le filtrage
    this.updatePagination();
  }




  addProjetToActiviter(item: any) {

    ////console.log("item");

    this.localstorage.saveProjetActivite(item);

    this.router.navigate(['/suivi/planification/projet-activite'])
  }



  openModal(item: any) {
    this.item.recommandation_id = item.reference
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
  close() {
    this.modalService.dismissAll()
  }


  //confirme la suppression
  confirmSuppression(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette suivi de  recommandation ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deletesuiviReccomandation(item.reference).subscribe(

          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.getRecommandation(this.id);
          },
          (error) => {
            ////console.log("une erreur est survenu",error);
            this.ngxService.stop();
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error });

          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'error', summary: 'X-Project', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }//end confirmDelet
}